import { H1, H2, Icon } from "@blueprintjs/core";
import * as queryString from "query-string";
import * as React from "react";
import { withRouter } from "react-router-dom";
import Wheel from "../components/Wheel/index";
import firebase from "../firebase";
import { firestore } from "../firebase";
import "../styles/wheel.css";

interface WheelState {
  businessDoc: any;
  businessId: string;
  mobile: string;
  wheelId: string;
  wheelError: string;
  wheelName: string;
  wheelOptions: any[];
  selectedItem: any;
  loading: boolean;
}

interface IBarGraphProps {
  onSelectItem?: any;
  location: any;
}

class Wheels extends React.Component<IBarGraphProps, WheelState> {
  public state: WheelState = {
    businessDoc: {},
    businessId: "",
    loading: true,
    mobile: "",
    selectedItem: null,
    wheelError: "",
    wheelId: "",
    wheelName: "",
    wheelOptions: [],
  };

  constructor(props) {
    super(props);
  }

  public componentDidMount() {
    console.log("MOUNTING WHEELS...");
    this.getWheel();

    this.selectItem = this.selectItem.bind(this);
  }

  public async selectItem() {
    const { mobile, wheelId } = this.state;
    const wheelUser = await firestore
      .collection("wheelUsers")
      .where("mobile", "==", mobile)
      .where("wheelId", "==", wheelId)
      .get();
    if (wheelUser.size > 0) {
      let wheelOption;
      wheelUser.forEach((doc) => {
        const singleDoc = doc.data();
        wheelOption = singleDoc.wheelOption;
      });
      alert("User already won " + wheelOption.label + " coupon!");
      return;
    }
    if (this.state.selectedItem === null) {
      const selectedItem = Math.floor(
        Math.random() * this.state.wheelOptions.length
      );
      this.addWheelOptionToUser(selectedItem);
      if (this.props.onSelectItem) {
        this.props.onSelectItem(selectedItem);
      }
      this.setState({ selectedItem });
    } else {
      this.setState({ selectedItem: null });
      setTimeout(this.selectItem, 500);
    }
  }

  public render() {
    const {
      businessDoc,
      loading,
      wheelError,
      wheelName,
      wheelOptions,
    } = this.state;
    if (loading) {
      return (
        <div>
          <br />
          <br />
          <br />
          <H1>
            Loading...{" "}
            <Icon className="icon-spin" icon="refresh" iconSize={40} />
          </H1>
        </div>
      );
    }
    if (wheelError) {
      return (
        <div style={{ margin: "10px auto" }}>
          <div style={{ textAlign: "center" }}>
            <H1>{wheelError}</H1>
          </div>
        </div>
      );
    }
    return (
      <div className="wheel-area">
        {wheelOptions.length > 0 ? (
          <div>
            <div className="business-part">
              <div className="busuness-name">
                <H1>{businessDoc.yardName}</H1>
              </div>
              <div className="busuness-logo">
                <img src={businessDoc.logo} />
              </div>
            </div>

            <div className="wheel-part">
              <H1>Spin the wheel for a coupon reward!</H1>
              {wheelName && <H1>{wheelName}</H1>}
            </div>
            <div className="wheel-main">
              <div className="wheel-dollar">
                <Wheel
                  items={wheelOptions}
                  selectItem={this.selectItem}
                  selectedItem={this.state.selectedItem}
                />
              </div>
              <div className="claim_text">
                <H2>Unlock Free Spin</H2>
                <p>
                  Spin the wheel for a coupon reward. Show the text to the
                  cashier to redeem!
                </p>
              </div>
            </div>
          </div>
        ) : (
          <H1>Wheel id or mobile is not found!</H1>
        )}
      </div>
    );
  }

  public addWheelOptionToUser = async (WheelOptionIndex: number) => {
    const { businessId, mobile, wheelId, wheelOptions } = this.state;
    if (wheelId && wheelOptions[WheelOptionIndex] && mobile) {
      const wheelUser = await firestore
        .collection("wheelUsers")
        .where("mobile", "==", mobile)
        .where("wheelId", "==", wheelId)
        .get();

      if (wheelUser.size === 0) {
        await firestore.collection(`wheelUsers`).add({
          createdAt: new Date().valueOf(),
          mobile,
          wheelId,
          wheelOption: wheelOptions[WheelOptionIndex],
        });

        const couponGuid = wheelOptions[WheelOptionIndex].guid;

        this.sendMessage({
          businessId,
          couponGuid,
          mobile,
          wheelOption: wheelOptions[WheelOptionIndex].label,
        });

        setTimeout(() => {
          alert(
            "You won a " + wheelOptions[WheelOptionIndex].label + " coupon!"
          );
        }, 5000);
      }
    }
  };

  public sendMessage = async (data: any) => {
    const { businessId, couponGuid, mobile, wheelOption } = data;
    const business = await firestore
      .collection("businesses")
      .doc(businessId)
      .get();
    if (business.exists) {
      const businessData = business.data();
      if (businessData) {
        const sendData = {
          couponguid: couponGuid,
          keyword: businessData.justInKeyword,
          message: "You won a " + wheelOption + " coupon! ~redeem~",
          mobile,
          shortcode: businessData.shortcode,
          user_guid: businessData.guid,
        };
        try {
          const sendWheelMessage = firebase
            .functions()
            .httpsCallable("sendWheelMessage");
          const sendMessage = await sendWheelMessage(sendData);

          console.log("sendMessage", sendMessage);
        } catch (error) {
          console.log("error", error);
        }
      }
    }
  };

  private getWheel = async () => {
    document.body.classList.add("spin-wheel");
    const params = queryString.parse(this.props.location.search);

    const businessDoc: any = {};
    let businessId = "";
    let wheelOptions = [];
    let wheelId = "";
    let wheelName = "";
    let mobile = "";
    if (params.wheel_id && params.mobile) {
      wheelId = (params.wheel_id as string).trim();
      mobile = (params.mobile as string).trim();

      const wheelUser = await firestore
        .collection("wheelUsers")
        .where("mobile", "==", mobile)
        .where("wheelId", "==", wheelId)
        .get();

      if (wheelUser.size > 0) {
        let wheelOption;
        wheelUser.forEach((doc) => {
          const singleDoc = doc.data();
          wheelOption = singleDoc.wheelOption;
        });

        const wheelError = "User already won " + wheelOption.label + " coupon!";

        this.setState({ wheelError });
      } else {
        const wheel = await firestore
          .collection("wheels")
          .doc(wheelId)
          .get();
        if (wheel.exists) {
          const wheelData = wheel.data();
          if (wheelData && wheelData.status === "enable") {
            businessId = wheelData.businessId;
            wheelOptions = wheelData.options;
            wheelName = wheelData.wheelName;

            const business = await firestore
              .collection("businesses")
              .doc(businessId)
              .get();
            if (business.exists) {
              const businessData = business.data();
              if (businessData) {
                businessDoc.yardName = businessData.yardName;
                businessDoc.logo = businessData.theme.logo;
              }
            }
          }
        }
        this.setState({ businessDoc, wheelName, wheelOptions });
      }
    }

    this.setState({ businessId, loading: false, mobile, wheelId });
  };
}

export default withRouter(Wheels);



// WEBPACK FOOTER //
// ./src/views/Wheels.tsx